var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Editor',{attrs:{"api-key":"km60m6tmfn9gu740t93gc5b36fzfuplv9t0qkq7g534ikc7v","init":{
    plugins: 'link image lists code fullscreen anchor table',
    menubar: false,
    toolbar: 'undo redo | bold italic underline h2 h3 h4 | table tabledelete | alignleft aligncenter alignright | numlist bullist image | cut copy paste selectall | link unlink anchor | code fullscreen',
    contextmenu: 'cut copy paste selectall',
    statusbar: false,
    height: _vm.height,
    progressBar: true,
    toolbar_sticky: true,
    images_file_types: 'jpeg,jpg,png,gif,webp,svg',
    file_picker_callback: _vm.my_file_picker_callback,
}},model:{value:(_vm.dataModel),callback:function ($$v) {_vm.dataModel=$$v},expression:"dataModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }